import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ReviewsEffects } from './reviews.effects';

export const effects: any[] = [ReviewsEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
})
export class ReviewsEffectsModule {}
